import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Wrench, Briefcase } from 'lucide-react';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      {/* Header */}
      <header className="px-4 py-5 border-b border-gray-200">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold" style={{ color: 'var(--primary-strong)' }}>Providers</h1>
        </div>
      </header>

      {/* Hero Section */}
      <main className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] px-4 py-12">
        <div className="max-w-2xl w-full text-center space-y-8">
          <div className="space-y-4">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold" style={{ color: 'var(--dark-primary)' }}>
              ¿Qué necesitás?
            </h2>
            <p className="text-lg text-gray-600 max-w-lg mx-auto">
              Conectamos personas que necesitan servicios con profesionales calificados
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6 mt-12 max-w-2xl mx-auto">
            {/* Usuario Button */}
            <div
              data-testid="need-professional-btn"
              className="relative overflow-hidden rounded-2xl p-8"
              style={{ 
                backgroundColor: 'var(--primary-strong)',
                boxShadow: '0 10px 40px rgba(255, 127, 53, 0.3)'
              }}
            >
              <div className="relative z-10 flex flex-col items-center space-y-4 text-white">
                <div className="p-4 rounded-full bg-white/20 backdrop-blur-sm">
                  <Wrench className="w-10 h-10" />
                </div>
                <div className="space-y-2">
                  <h3 className="text-2xl font-bold">Necesito un profesional</h3>
                  <p className="text-sm text-white/90">Publicar mi solicitud de trabajo</p>
                </div>
              </div>
            </div>

            {/* Profesional Button */}
            <button
              data-testid="am-professional-btn"
              onClick={() => navigate('/profesionales')}
              className="group relative overflow-hidden rounded-2xl p-8 transition-all hover:scale-105"
              style={{ 
                backgroundColor: 'var(--dark-primary)',
                boxShadow: '0 10px 40px rgba(17, 17, 17, 0.3)'
              }}
            >
              <div className="relative z-10 flex flex-col items-center space-y-4 text-white">
                <div className="p-4 rounded-full bg-white/10 backdrop-blur-sm">
                  <Briefcase className="w-10 h-10" />
                </div>
                <div className="space-y-2">
                  <h3 className="text-2xl font-bold">Soy profesional</h3>
                  <p className="text-sm text-white/90">Ver trabajos disponibles</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 py-6 px-4">
        <div className="max-w-6xl mx-auto text-center text-sm text-gray-500 space-y-2">
          <p>© 2026 Providers. Conectando profesionales con quienes los necesitan.</p>
          <Link
            to="/terminos"
            className="inline-block text-gray-400 hover:text-gray-600 hover:underline transition-colors"
            data-testid="terms-link"
          >
            Términos y Condiciones
          </Link>
        </div>
      </footer>
    </div>
  );
}
